import { gsap } from "gsap";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

import RoadmapCard from "../components/RoadmapCard";
import roadmap_img from "../assets/roadmap.png";

const Roadmap = () => {
  const [animated, setAnimated] = useState(false);
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView && !animated) {
      let tl = gsap.timeline();

      tl.from("#roadmap-h", {
        delay: 0.25,
        opacity: 0,
        transform: "scale(0.5) rotate(-5deg)",
      });

      tl.from(".roadmap-item", {
        stagger: 0.1,
        opacity: 0,
        y: 100,
      });

      setAnimated(!animated);
    }
  }, [inView]);

  return (
    <div
      ref={ref}
      id="roadmap"
      className="min-vh-100 d-flex flex-column justify-content-center align-items-center text-center container"
      style={{ marginTop: 50 }}
    >
      <h1 id="roadmap-h" className="primary-h">
        Roadmap
      </h1>
      <section class="roadmap" id="roadmap-section">
        <ul>
          <RoadmapCard
            id={1}
            title={"PHASE 1"}
            desc={
              "<ul><li>We start our discord and website.</li><li>Reward the growing community with I giveaways including ETH, NFTS and Special Roles within the community with Whitelisting Benefits.</li><li>We will launch the Gutter Bats Planet NFT Collection.</li><li>We release the Caged Bats (5 NFT's that held back from the sale) They will be randomly airdropped to the holders.</li></ul>"
            }
          />
          <RoadmapCard
            id={2}
            title={"PHASE 2"}
            desc={
              "<ul><li>Merch Store will become active and special merches will be there for you.</li><li>First Member-Only Giveaway will take place with exclusive prizes.</li><li>Current Holders will be rewarded with exclusive airdrops.</li><li>First Metaverse Meet-up will take place.</li></ul>"
            }
          />
          <RoadmapCard
            id={3}
            title={"PHASE 3"}
            desc={
              "<ul><li>New Gutter Bats breeding will be air-dropped to the NFT holders randomly.</li><li>All holders will begin to receive our token for amount of holding time.</li><li>The Gutter Bats Planet Metaverse will launch with Exclusive Benefits and Rights for NFT Holders.</li></ul>"
            }
          />
        </ul>
      </section>
      <img
        src={roadmap_img}
        style={{
          border: "1px solid var(--primary)",
          borderRadius: 10,
          width: "100%",
        }}
      />
    </div>
  );
};

export default Roadmap;
